<template>
  <v-container fluid>
     <v-row
        align="center"
        justify="center"
        class="mx-0"
      >
        <v-col cols="12" md="6">
            <v-card>
              <v-card-text>
                <v-row justify="center" align="center">
                  <v-col cols="12">
                    <v-row class="mb-5" justify="center" align="center">
                      <img src="../assets/08_WebApp_Pappyon.jpg" height="60" width="60"/>
                    </v-row>
                    <p class="text-h5 text-center secondary--text">Manage your Premiere<br/>Business Profile</p>
                    <p class="text-subtitle-1 text-center mt-n3 secondary--text">Your Premiere Profile is your public business profile<br/>which shows on the Pappyon App.</p>
                    <v-row justify="center" align="center">
                      <v-btn to="/managePremiereProfile" class="secondary" width="250" large elevation="0">Manage Premiere Profile</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" md="6">
            <v-card>
              <v-card-text>
                <v-row justify="center" align="center">
                  <v-col cols="12">
                    <v-row class="mb-5" justify="center" align="center">
                      <img src="../assets/logo-large.png" height="60" width="60"/>
                    </v-row>
                    <p class="text-h5 text-center secondary--text">Post to your<br/>Newsfeed & view past activity</p>
                    <p class="text-subtitle-1 text-center mt-n3 secondary--text">Share important updates with the Pappyon<br/>community and your followers.</p>
                    <v-row justify="center" align="center">
                      <v-btn to="/newsfeed" class="secondary" width="250" large elevation="0">Open Newsfeed</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
        </v-col>
     </v-row>
     <v-row
        align="center"
        justify="center"
        class="mx-0"
      >
        <v-col cols="12" md="6">
            <v-card disabled>
              <v-card-text>
                <v-row justify="center" align="center">
                  <v-col cols="12">
                    <v-row class="mb-5" justify="center" align="center">
                      <img src="../assets/logo-large.png" height="60" width="60"/>
                    </v-row>
                    <p class="text-h5 text-center secondary--text">Your Followers</p>
                    <p class="text-subtitle-1 text-center mt-n3 secondary--text">See who follows your Premiere<br/>Business Profile.</p>
                    <v-row justify="center" align="center">
                      <v-btn class="secondary" width="250" large elevation="0">View Followers</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" md="6">
            <v-card disabled>
              <v-card-text >
                <v-row justify="center" align="center">
                  <v-col cols="12">
                    <v-row class="mb-5" justify="center" align="center">
                      <img src="../assets/logo-large.png" height="60" width="60"/>
                    </v-row>
                    <p class="text-h5 text-center secondary--text">Your Members (Coming Soon)</p>
                    <p class="text-subtitle-1 text-center mt-n3 secondary--text">Badge your members’ Pappyon cards with<br/>your organisation’s offical seal.</p>
                    <v-row justify="center" align="center">
                      <v-btn class="secondary" width="250" large elevation="0">Coming Soon!</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
        </v-col>
     </v-row>
  </v-container>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'PappyonPremiere',
}
</script>
